import {
  Journey,
  SolutionJourneyTabs,
} from "../../FuturebilityCockpit/components/SolutionJourneyTabs";

type SolutionJourneySectionProps = {
  journey1: Journey;
  journey2: Journey;
  journey3: Journey;
  activeJourneyId: string;
  activeJourneyItemId: string;
  title: string;
  question: string;
  answer: string;
  color: string;
};

const SolutionJourneySection = ({
  journey1,
  journey2,
  journey3,
  activeJourneyId,
  activeJourneyItemId,
  title,
  question,
  answer,
  color,
}: SolutionJourneySectionProps) => {
  return (
    <div className="solution-journey-wrapper" style={{ color: color }}>
      <SolutionJourneyTabs
        journey1={journey1}
        journey2={journey2}
        journey3={journey3}
        activeJourneyId={activeJourneyId}
        activeJourneyItemId={activeJourneyItemId}
        onJourneyClicked={() => {}}
      />

      <div className="solution-journey-text-wrapper">
        <div className="title">{title}</div>
        <div>{question}</div>
        <div className="text">{answer}</div>
      </div>
    </div>
  );
};

export default SolutionJourneySection;
